import React from 'react';
import PropTypes from 'prop-types';
import { linkType } from '../propTypes';
import get from '../helpers/get';
import withGtm from './withGtm';

const getLinkRel = ({ target, rel }) => (
  (target === '_blank' && !rel) ? 'noopener noreferrer' : rel
);

const selectTag = (hasLink, inline) => {
  if (hasLink) {
    return 'a';
  }
  if (inline) {
    return 'span';
  }
  return 'div';
};

const Link = ({
  children,
  defaultText,
  inline,
  link,
  ...rest
}) => {
  // We can't force users to populate fields in Prismic, so we need to handle missing links
  // gracefully
  const hasLink = !!get(link, ['url']);
  const Tag = selectTag(hasLink, inline);
  const props = { ...rest };
  if (hasLink) {
    props.href = link.url;
    props.rel = getLinkRel(link);
    props.target = link.target;
  }
  return (
    <Tag {...props}>
      {children || get(link, ['text']) || defaultText}
    </Tag>
  );
};

Link.propTypes = {
  children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  defaultText: PropTypes.string,
  inline: PropTypes.bool,
  link: linkType,
};

Link.defaultProps = {
  children: undefined,
  defaultText: undefined,
  inline: false,
  link: undefined,
};

export default withGtm(Link);
